import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=1e5488b6&"
import script from "./SearchIndex.vue?vue&type=script&lang=js&"
export * from "./SearchIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports